import { COLORS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const styleSheet = createStyleSheet({
  container: {
    width: 1000,
    margin: 'auto',
    marginTop: 80,

    paddingTop: 40,
    paddingBottom: 48,
    paddingLeft: 30,
    paddingRight: 30,

    borderRadius: 4,
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  noStatsMessage: {
    fontFamily: 'Source Sans Pro',
    fontSize: 16,
    lineHeight: 'normal',
    fontWeight: 600,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 226,
    borderRadius: 8,
    borderColor: COLORS.GREY_MEDIUM.DEFAULT,
    borderWidth: 1,
    borderStyle: 'solid',
    marginBottom: 16,
  },
});

export default styleSheet;
